import { useCallback } from "react"
import { getProjectSetting } from "actions/project/setting/detailStatus"

export const useGetProjectSetting = () => {
  const getDetailProjectSetting = useCallback(async (projectId) => {
    const result = await getProjectSetting(projectId);
    return result;
  }, [])

  return getDetailProjectSetting;
}